export const ENTITY_VARS = {};
const ENTITY_DETAILS = {
  'fulfilment-np.bpost.cloud': 'bpost',
  'fulfilment-np-internal.bpost.cloud': 'bpost_internal',
  'fulfilment.bpost.cloud': 'bpost_prod',
  'fulfilment-internal.bpost.cloud': 'bpost_prod_internal',
  'radial-st1.bpost.cloud': 'radial',
  'radial.bpost.cloud': 'radial_prod',
  localhost: 'radial',
};
export const DOMAIN_NAME = window.location.hostname;
export const CURRENT_ENTITY = ENTITY_DETAILS[DOMAIN_NAME];
export const DEFAULT_ENTITY = 'radial';
const AUTH_PROD_ISSUER = 'https://login.bpost.be';
const PROD_LOGOUT_URL = 'https://login.bpost.be/idp/startSLO.ping';
const AUTH_NON_PROD_ISSUER = 'https://ssociam-np.bpost.cloud';
const CIAM_LOGOUT_URL = 'https://ssociam-np.bpost.cloud/idp/startSLO.ping';
const WIAM_NON_PROD_ISSUER = 'https://wiam-np.bpost.cloud';
ENTITY_VARS['radial'] = {
  clientId: 'radial_ciam_np',
  logoName: 'paxon_rgb_v2',
  issuer: AUTH_NON_PROD_ISSUER,
  logoutUrl: CIAM_LOGOUT_URL,
  title: 'Radial Client Portal',
  icon: '/assets/images/radial/favicon.ico',
};
ENTITY_VARS['bpost'] = {
  clientId: 'bpostb2b_fulfilment_np',
  logoName: 'bpost/bnode_logo_main_rgb',
  issuer: AUTH_NON_PROD_ISSUER,
  logoutUrl: CIAM_LOGOUT_URL,
  title: 'Bpost Fulfilment Portal',
  icon: '/assets/images/bpost/favicon.ico',
};
ENTITY_VARS['bpost_internal'] = {
  clientId: 'bpostb2b_fulfilment_wiam_np',
  logoName: 'bpost/bnode_logo_main_rgb',
  issuer: WIAM_NON_PROD_ISSUER,
  logoutUrl: 'https://wiam-np.bpost.cloud/idp/startSLO.ping',
  title: 'Bpost Internal Client Portal',
  icon: '/assets/images/bpost/favicon.ico',
};
ENTITY_VARS['bpost_prod'] = {
  clientId: 'bpostb2b_fulfilment_ciam_prd',
  logoName: 'bpost/bnode_logo_main_rgb',
  issuer: AUTH_PROD_ISSUER,
  logoutUrl: PROD_LOGOUT_URL,
  title: 'Bpost Fulfilment Portal',
  icon: '/assets/images/bpost/favicon.ico',
};
ENTITY_VARS['bpost_prod_internal'] = {
  clientId: 'bpostb2b_fulfilment_wiam_prd',
  logoName: 'bpost/bnode_logo_main_rgb',
  issuer: 'https://login.bpost.cloud',
  logoutUrl: 'https://login.bpost.cloud/idp/startSLO.ping',
  title: 'Bpost Internal Client Portal',
  icon: '/assets/images/bpost/favicon.ico',
};
ENTITY_VARS['radial_prod'] = {
  clientId: 'radial_ciam_prod',
  logoName: 'paxon_rgb_v2',
  issuer: AUTH_PROD_ISSUER,
  logoutUrl: PROD_LOGOUT_URL,
  title: 'Radial Client Portal',
  icon: '/assets/images/radial/favicon.ico',
};
ENTITY_VARS['staci_prod'] = {
  clientId: 'bpostb2b_fulfilment_ciam_prd',
  logoName: 'paxon_rgb_v2',
  issuer: AUTH_PROD_ISSUER,
  logoutUrl: PROD_LOGOUT_URL,
  title: 'Staci Fulfilment Portal',
  icon: '/assets/images/radial/favicon.ico',
};
ENTITY_VARS['staci'] = {
  clientId: 'bpostb2b_fulfilment_np',
  logoName: 'paxon_rgb_v2',
  issuer: AUTH_NON_PROD_ISSUER,
  logoutUrl: CIAM_LOGOUT_URL,
  title: 'Staci Fulfilment Portal',
  icon: '/assets/images/radial/favicon.ico',
};
ENTITY_VARS['activeants'] = {
  clientId: 'bpostb2b_fulfilment_np',
  logoName: 'paxon_rgb_v2',
  issuer: AUTH_NON_PROD_ISSUER,
  logoutUrl: CIAM_LOGOUT_URL,
  title: 'Active Ants Fulfilment Portal',
  icon: '/assets/images/radial/favicon.ico',
};
